import { IPartnerAppSettings } from '../interface/IPartnerAppSettings';

export const dev: IPartnerAppSettings = {
  cdnBaseUrl: 'https://esxp-weeklydigest-buhhe4ehe4fnefb9.b02.azurefd.net/weekly-digest',
  serviceEndPoints: [
    {
      clientId: 'api://b68ad24f-c1d9-4b37-b42f-9564a4609b2f',
      serviceEndPoint: 'https://professionalservicesint.microsoft.com/csp-uat-api',
    },
    {
      clientId: 'api://b68ad24f-c1d9-4b37-b42f-9564a4609b2f',
      serviceEndPoint: 'https://fd-csp-uat-gzajdgfvctb6cdew.z01.azurefd.net/csp-api',
    },
    {
      clientId: 'api://b68ad24f-c1d9-4b37-b42f-9564a4609b2f',
      serviceEndPoint: 'https://fd-csp-powerpoint-export-uat-a5hbg8c3hkhrdgbt.z01.azurefd.net/api',
    },
    {
      clientId: '3fc163a0-3df4-4395-8e24-90c0ff946802',
      serviceEndPoint: 'https://servicesuat.microsoft.com/mdm'
    },
    {
      clientId: '181ef486-9e47-4ad6-9454-7a326432dc00',
      serviceEndPoint: 'https://professionalservicesint.microsoft.com/dmuat/'
    },
    {
      clientId: 'api://fe0b5c1b-0c23-4b97-a9b3-0dd393fcbaba',
      serviceEndPoint: 'https://hygieneuat.trafficmanager.net/'
    },
    {
      clientId: 'api://1aaf894a-0fdb-487c-ace5-cc90e423ff5c',
      serviceEndPoint: 'https://nebulaapiuat.azurefd.net/'
    }
  ],
  HygieneAppConfiguration: {
    'HygieneBaseUri': 'https://hygieneuat.trafficmanager.net',
    'GetHierarchy': '/api/GetHierarchy?identifier=%s',
    'GetFactoryWorkloadMilestones': '/api/Milestone/GetEngagementMilestonesByOwner?ownerId=%s',
    'FactoryEligibleMilestonesUrl': 'https://microsoft.seismic.com/Link/Content/DCQC3mp4RQCgbGfRVF74997bVBmB#/?anchorId=9dbb39ba-cc9b-4f68-9a5a-6a5cfcd1de57'
  },
  NebulaAppConfiguration: {
    'NebulaApiBaseUrl': 'https://nebulaapiuat.azurefd.net',
    'NebulaSubscriptionKey': '8B16D17C-6C3E-4079-8D4D-2FADFD9E62F0',
    'NebulaAuthScope': 'api://1aaf894a-0fdb-487c-ace5-cc90e423ff5c/.default',
    'NebulaCmpSubscriptionKey': '02642B6E-676C-48D0-B377-4C16985A0993',
  },
  MSXAppConfiguration: {
    'MSXBaseUrl': 'https://msxuat.crm.dynamics.com/main.aspx?appid=fe0c3504-3700-e911-a849-000d3a10b7cc&',
    'ESXPCustomersBaseUrl': 'https://servicesuat.microsoft.com/#/customers'
  }
};
